import { Image, Modal, Form, Button } from "react-bootstrap";
import "../../assets/scss/components/templates/modal.scss";
import closeBtn from "../../assets/images/home/closeModal.svg";
import Btn from "./button";

const VerificationModal = (props) => {
  return (
    <Modal
      show={props.showmodal}
      onHide={props.closemodal}
      className="custom-modal verification-modal"
    >
      <div className="d-flex justify-content-end" closeButton>
        <Image
          src={closeBtn}
          onClick={props.closemodal}
          className="close-btn"
        />
      </div>
      <div className="text-center d-flex flex-column justify-content-center align-items-center">
        <h3 className="mb-4">
          You need to Create an account for creating Resume
        </h3>
        <Form className="modal-form">
          <div className="d-flex align-items-center justify-content-between">
            <Form.Group className="input-field no-spinner">
              <Form.Control type="number" />
            </Form.Group>
            <Form.Group className="input-field no-spinner">
              <Form.Control type="number" />
            </Form.Group>
            <Form.Group className="input-field no-spinner">
              <Form.Control type="number" />
            </Form.Group>
            <Form.Group className="input-field no-spinner">
              <Form.Control type="number" />
            </Form.Group>
            <Form.Group className="input-field no-spinner">
              <Form.Control type="number" />
            </Form.Group>
          </div>
          <Btn
            text="Confirm Verification Code"
            class="btn-primary continue-with-email"
          />
        </Form>
        <p className="resend-code paragraph-small-regular mb-3">
          <a href="#">Resend Code</a>
        </p>
      </div>
    </Modal>
  );
};

export default VerificationModal;
